import * as React from 'react';
import styled from 'styled-components'
import {ConstBreakPoint} from "../../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const CancelButtonWrapperDefault: React.SFC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const CancelButtonWrapper = styled(CancelButtonWrapperDefault)`
    display: none;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: block;
        position: absolute;
        left: 0;
    }
`;

export default CancelButtonWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper.tsx